import Raven                 from "raven-js"
import React                 from "react"
import ReactDOM              from "react-dom"
import { Provider }          from "react-redux"
import ErrorBoundary         from "./ErrorBoundary"
import "./index.css"
import registerServiceWorker from "./registerServiceWorker"
import Router                from "./router"
import store                 from "./store"
import {
    getEnvironment,
    isDevelopment,
}                            from "./utils/core-helpers"

if (!isDevelopment()) {
    Raven.config("https://e8d9856a86f84c65b60e147d6cb35655@sentry.io/1821155", {
             // release: "release", @todo: get release version
             environment: getEnvironment(),
         })
         .install()
}

//store language into global var
window.language = localStorage.getItem("language") || "en"

ReactDOM.render(
    <Provider store={store}>
        <ErrorBoundary>
            <Router/>
        </ErrorBoundary>
    </Provider>,
    document.getElementById("root"),
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js